import React from 'react'
import { Field } from 'redux-form';
import { Item, painel, fieldset } from 'scorpion-core';
import Seletor from './components/Seletor'

import EditorSeletor from '../../editor/SeletorUidCustomForm'
import Sel from '../../editor/Sel'
import DinamicCrudCustomPesquisa from '../../../DinamicForms/components/DinamicCrudCustomPesquisa'

import EditorCodigo from '../../editor/EditorCodigo'

function componentRelEspelho(comp, dados) {
    return fieldset(comp.label, painel("nao implementadao", { widths: ['*'] }))
}

function component(item) {

    let tmpFunctoStringItem = null;

    try {
        tmpFunctoStringItem = new Function("return " + item.toStringItem)();

    } catch (error) {
        // console.log('error', error);
    }

    return (<Item key={item.sha} style={{ flex: 1 }}>
        <Field name={item.field} label={item.label}
            toStringItem={tmpFunctoStringItem || (item => item)}
            itemToValue={(t) => t}
            pesquisa={<DinamicCrudCustomPesquisa customFormUid={item.customFormUid} titulo={item.label}  />} component={Sel} />
    </Item>)
}

const modelo = {
    field: "seletorCustom",
    label: "seletorCustom",
    typeComponente: "seletorCustom",
    customFormUid: "",
    toStringItem: `function toStringItemF(item){
        try {
        return item;
        } catch (error) {
        // console.log('error', error);
        }
    }`
}

const comp = {
    typeComponente: "seletorCustom",
    configView: {
        nome: "Seletor Custom Form",
        modelo,
        editores: {
            customFormUid: EditorSeletor,
            toStringItem: EditorCodigo,
        },


    },
    componentRelEspelho,
    component
}

export default comp;


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/SeletorCustomForm/SeletorCustomFormComp.js